export const ERROR_RPS_SUBSCRIPTION_INFORMATION =
  'ERROR_RPS_SUBSCRIPTION_INFORMATION';
export const RECEIVED_RPS_SUBSCRIPTION_INFORMATION =
  'RECEIVED_RPS_SUBSCRIPTION_INFORMATION';
export const REQUESTED_RPS_SUBSCRIPTION_INFORMATION =
  'REQUESTED_RPS_SUBSCRIPTION_INFORMATION';
export const REQUESTED_UNLINK_RPS_SUBSCRIPTION =
  'REQUESTED_UNLINK_RPS_SUBSCRIPTION';
export const REQUESTED_LINK_RPS_SUBSCRIPTION =
  'REQUESTED_LINK_RPS_SUBSCRIPTION';
export const RECEIVED_UPDATE_RPS_SUBSCRIPTION =
  'RECEIVED_UPDATE_RPS_SUBSCRIPTION';
export const ERROR_UNLINK_RPS_SUBSCRIPTION = 'ERROR_UNLINK_RPS_SUBSCRIPTION';
export const ERROR_LINK_RPS_SUBSCRIPTION = 'ERROR_LINK_RPS_SUBSCRIPTION';

export const errorRpsSubscriptionInformation = (error) => ({
  type: ERROR_RPS_SUBSCRIPTION_INFORMATION,
  error
});

export const receivedRpsSubscriptionInformation = (response) => ({
  type: RECEIVED_RPS_SUBSCRIPTION_INFORMATION,
  payload: {
    ...response
  }
});

export const requestedRpsSubscriptionInformation = () => ({
  type: REQUESTED_RPS_SUBSCRIPTION_INFORMATION
});

export const requestedUnlinkRpsSubscription = () => ({
  type: REQUESTED_UNLINK_RPS_SUBSCRIPTION
});

export const requestedLinkRpsSubscription = () => ({
  type: REQUESTED_LINK_RPS_SUBSCRIPTION
});

export const errorUnlinkRpsSubscription = () => ({
  type: ERROR_UNLINK_RPS_SUBSCRIPTION
});

export const errorLinkRpsSubscription = () => ({
  type: ERROR_LINK_RPS_SUBSCRIPTION
});

export const recievedUpdateRpsSubscription = (response) => ({
  type: RECEIVED_UPDATE_RPS_SUBSCRIPTION,
  payload: {
    ...response
  }
});
